import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 55 56"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m28.016 29.146 5.213-3.151 5.214 3.151-1.375-5.958 4.583-3.953-6.016-.516-2.406-5.615-2.406 5.615-6.016.515 4.584 3.954zm1.088 14.896h12.833q-.4 1.49-1.375 2.406-.974.916-2.52 1.146l-24.98 3.036q-1.89.287-3.408-.888-1.519-1.174-1.748-3.065L4.87 21.641q-.229-1.89.916-3.38t3.037-1.72l2.635-.343v4.583l-2.062.287 3.093 25.036zm-8.48-4.584q-1.89 0-3.236-1.346t-1.346-3.237V9.667q0-1.89 1.346-3.237 1.345-1.347 3.237-1.346h25.208q1.89 0 3.237 1.346t1.347 3.237v25.208q0 1.89-1.347 3.237-1.345 1.346-3.237 1.346H20.625Zm0-4.583h25.21V9.667h-25.21z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }